import { render, staticRenderFns } from "./SummaryCases.vue?vue&type=template&id=ca614dfc&scoped=true&"
import script from "./SummaryCases.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummaryCases.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SummaryCases.vue?vue&type=style&index=0&id=ca614dfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca614dfc",
  null
  
)

export default component.exports